import styled, { css } from 'styled-components';
import { Icon, Modal } from 'src/components';
import { CardContainer as CardContainerComponentStyled } from 'src/components/CardContainer/styles'; // TO-DO: styled-components - must import from stylesheet directly

export const ModalWrapper = styled(Modal)(
  ({ theme }) => css`
    @media (max-width: ${theme.sz.md}) {
      .reactModalOverlay {
        align-items: flex-end;
        padding: 0;
      }

      .reactModalContent {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        overflow: hidden;
        margin: 0;
        position: fixed;
        bottom: 0;
      }
    }
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s5};
    margin-bottom: ${theme.sz.s4};
    margin: ${theme.sz.s14} ${theme.sz.s8};

    @media (max-width: ${theme.sz.md}) {
      margin: ${theme.sz.s14} ${theme.sz.s3} ${theme.sz.s5} ${theme.sz.s3};
    }
  `,
);

export const CardContainer = styled(CardContainerComponentStyled)(
  ({ theme }) => css`
    height: 100%;
    background-color: ${theme.co.primary98};
    padding: ${theme.sz.s4};
  `,
);

export const HeadingWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${theme.sz.s4};
  `,
);

export const CardContainerHeading = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary0};
    ${theme.typography.heading.desktop.xxs};
    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xxxs};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary30};
    ${theme.typography.paragraph.m};
  `,
);

export const FireIcon = styled(Icon)(
  ({ theme }) => css`
    margin-right: ${theme.sz.s2};
    font-size: ${theme.sz.s8};
  `,
);
